import React, { useEffect } from 'react';
import { Button, Checkbox, Form, Input, Modal } from 'antd';
import { UserOutlined } from '@ant-design/icons';

export default function UserFormModal({ visible, editingUser, onSubmit, onCancel }) {
    const [form] = Form.useForm();

    useEffect(() => {
        if (!visible) return;
        form.resetFields();
        if (editingUser) form.setFieldsValue(editingUser);
    }, [visible, editingUser, form]);

    return (
        <Modal
            title={editingUser ? 'Edit User' : 'Add User'}
            open={visible}
            onCancel={onCancel}
            footer={null}
        >
            <Form form={form} onFinish={onSubmit} layout="vertical">
                <Form.Item
                    name="username"
                    label="Username"
                    rules={[{ required: true, message: 'Please enter a username' }]}
                >
                    <Input prefix={<UserOutlined />} />
                </Form.Item>
                {!editingUser && (
                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[{ required: true, message: 'Please enter a password' }]}
                    >
                        <Input.Password />
                    </Form.Item>
                )}
                <Form.Item name="email" label="Email">
                    <Input placeholder="Enter Email" />
                </Form.Item>
                <Form.Item name="is_admin" valuePropName="checked">
                    <Checkbox>Is Admin</Checkbox>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        {editingUser ? 'Save Changes' : 'Create User'}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
}
